import "../../css/modules/swiper.css";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

function init() {
    new Swiper(".mySwiper", {
        modules: [Navigation, Pagination],
        pagination: {
            el: ".swiper-pagination"
        },
        slidesPerView: "auto",
        slidesOffsetAfter: 20,
        slidesOffsetBefore: 30
    });
}

export default { init };
